import component from '../../../plugins/element-ui/component'
import Menu from 'element-ui/lib/menu'

export default component(Menu, 'MenuWrapper')
